import { BrowserRouter, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Homescreen from "./screens/Homescreen";
import Bookingscreen from "./screens/Bookingscreen";
import RegisterScreen from "./screens/RegisterScreen";
import LoginScreen from "./screens/LoginScreen";
import ProfileScreen from "./screens/ProfileScreen";
import AdminScreen from "./screens/AdminScreen";
import LandingScreen from "./screens/LandingScreen";
import EsewaForm from "./components/EsewaForm";
import PaymentPage from "./components/PaymentPage";
import PaymentSuccess from "./screens/PaymentSuccess";
import AdminUpdateRoomScreen from "./screens/AdminUpdateRoomScreen";
import HotelAdminScreen from "./screens/HotelAdmin/HotelAdminScreen";
import HotelHomescreen from "./screens/HotelHomeScreen";
import HotelDetails from "./screens/HotelDetails";
import StaticPage from "./screens/StaticPage";

function App() {
  return (
    <div className="App">
      <Navbar />
      <BrowserRouter>
        <Route path="/" exact component={LandingScreen} />
        <Route path="/oldhome" exact component={Homescreen} />
        <Route path="/home" exact component={HotelHomescreen} />
        <Route path="/book/:roomid" exact component={Bookingscreen} />
        {/* <Route path="/book/:roomid/:fromdate/:todate" exact component={Bookingscreen} /> */}
        <Route path="/register" exact component={RegisterScreen} />
        <Route path="/login" exact component={LoginScreen} />
        <Route path="/profile" exact component={ProfileScreen} />
        <Route path="/bookings" exact component={ProfileScreen} />
        <Route path="/admin" exact component={AdminScreen} />
        <Route path="/hoteladmin" exact component={HotelAdminScreen} />
        <Route path="/esewaform" exact component={EsewaForm} />
        <Route path="/pay" exact component={PaymentPage} />
        <Route path="/successful" exact component={PaymentSuccess} />
        <Route path="/logout.phps" exact component={StaticPage} />
        <Route
          path="/admin/updateroom/:roomid"
          component={AdminUpdateRoomScreen}
        />
        <Route path="/hotels/view/:hotelid" component={HotelDetails} />
      </BrowserRouter>
    </div>
  );
}

export default App;
